<template>

    <!-- :deletable-chips="!inDialog" -->
  <v-autocomplete
    v-model="selectedDays"
    :items="weekdaysArray"
    @input="updateDays"
    small-chips
    color="primary"
    :hint="$t('Select a list of weekdays that this plan will be apply too')"
    :persistent-hint="!inDialog"
    multiple
    hide-details

    :allow-overflow="false"
    class="set-width"
    >
    <!-- @input="$emit('update:selectedDays', selectedDays);"  -->
    <!-- :rule="[selectedDays.length == 0 ? 'At least one weekday should be selected!' : false]" -->
      <template v-slot:item="data" class="flex-container">
        <span class="weekday-list-item">
          {{data.item.text}}
        </span>
      </template>

      <template v-slot:label>
        <div class="font-weight-medium">
          {{inDialog? $t('Make wagon in days') + ":" : $t('Apply to Weekdays')}}
        </div>
      </template>

      <template v-slot:append>
        <v-tooltip bottom>
          <template v-slot:activator="{on}">
            <v-btn icon x-small color="primary" v-on="on" @click.stop="addAllDays" >
              <v-icon>mdi-check-all</v-icon>
            </v-btn>
          </template>
          <span>{{$t('Select all weekdays')}}</span>
        </v-tooltip>
      </template>
    </v-autocomplete>
</template>
<script>

export default {
  name: "WeekdayPicker",
  props: {
    inDialog: {
      type: Boolean,
      default: false,
      require: false
    },
    currentSelection: {
      type: Array,
      require: false
    }

  },
  data () {
    return {
      weekdaysArray: [
        { text:this.$i18n.t('Sun'),  value: 1},
        { text:this.$i18n.t('Mon'),  value: 2},
        { text:this.$i18n.t('Tue'),  value: 3},
        { text:this.$i18n.t('Wed'),  value: 4},
        { text:this.$i18n.t('Thu'),  value: 5},
        { text:this.$i18n.t('Fri'),  value: 6},
        { text:this.$i18n.t('Sat'),  value: 7},
      ],
    }
  },
  methods: {
    addAllDays() {
      this.$store.dispatch("actionSetSelectedDays", [1,2,3,4,5,6,7]);
      this.$nextTick(()=> this.$forceUpdate() );
    },
    updateDays(evnt) {
      if (this.inDialog)
        this.$emit('update:currentSelection', this.currentSelection.sort((a,b) => a-b) );
      else{
        this.$store.dispatch("actionSetSelectedDays", evnt)
        this.$nextTick(()=> this.$forceUpdate() );
      }
    }
  },
  computed: {
    selectedDays: {
       get () {
         if (this.inDialog)
          return this.currentSelection;
         else
          return this.$store.getters.getSelectedDays;
        },
        set (value) {
          if (this.inDialog)
            this.currentSelection = value;
          this.value = value;
        },
    }
  },

}
</script>
<style scoped>
  .set-width {
    max-width: 580px;
  }
</style>
